import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { BillingInformationContext } from "../BillingInformationContext";
import { usePaymentMethodCreate } from "../Shared/hooks/PaymentMethodCreate/usePaymentMethodCreate";
import { usePaymentMethodUpdate } from "../Shared/hooks/PaymentMethodUpdate/usePaymentMethodUpdate";
import { StatusType } from "../Shared/types/PaymentProcessorTypes";
import { callback, handleClose, onSubmit } from "./TapCardForm-utils";
const initTapCardFormState = {
    loading: false,
    status: {
        message: undefined,
        type: StatusType.IDLE,
    },
    submitted: false,
};
export const useTapCardForm = (selectedCard) => {
    var _a;
    const [cardFormState, setCardFormState] = useState(initTapCardFormState);
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const { createPaymentMethod, loading } = usePaymentMethodCreate();
    const { updatePaymentMethod } = usePaymentMethodUpdate();
    const { publicKey, setAddedNewCard } = useContext(BillingInformationContext);
    const { handleSubmit, control, resetField } = useForm({
        mode: "onChange",
    });
    const defaultValues = {
        isPrimaryChecked: (_a = selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.isPrimary) !== null && _a !== void 0 ? _a : false,
    };
    const gateway = {
        callback: callback(handleSubmit, onSubmit, createPaymentMethod, updatePaymentMethod, setCardFormState, setAddedNewCard, selectedCard),
        publicKey: publicKey !== null && publicKey !== void 0 ? publicKey : "",
        language: "en",
        supportedCurrencies: "all",
        supportedPaymentMethods: "all",
        notifications: "msg",
        labels: {
            cardNumber: "Card Number",
            expirationDate: "MM/YY",
            cvv: "CVV",
            cardHolder: "Name on Card",
        },
        style: {
            base: {
                color: theme.typography.body1.color,
                lineHeight: theme.spacing(2.25),
                fontFamily: "sans-serif",
                fontSmoothing: "antialiased",
                fontSize: String(theme.typography.body1.fontSize),
                "::placeholder": {
                    color: "rgba(0, 0, 0, 0.26)",
                    fontSize: String(theme.typography.body1.fontSize),
                },
            },
            invalid: {
                color: `${theme.palette.error.main}`,
                iconColor: `${theme.palette.error.main}`,
            },
        },
    };
    return {
        loading: loading || cardFormState.loading,
        mobile,
        control,
        defaultValues,
        gateway,
        cardFormState,
        handleClose: handleClose(resetField, setCardFormState),
    };
};
